/**
 * Terms & Conditions accordion
 *
 * Only one category open at a time — opening one collapses whichever was
 * open; clicking an already-open category collapses it (reaches an
 * all-collapsed state, not "always exactly one open").
 *
 * Not reused from faq-collapse.js: that toggles every row independently
 * (no single-open constraint) — a different, incompatible behavior.
 */
document.addEventListener('DOMContentLoaded', function () {
    var triggers = document.querySelectorAll('.terms-accordion__trigger');
    var openTrigger = null;

    function closeTrigger(trigger) {
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        trigger.setAttribute('aria-expanded', 'false');
        trigger.classList.remove('is-open');
        if (panel) {
            panel.setAttribute('aria-hidden', 'true');
            panel.classList.remove('is-open');
            panel.style.maxHeight = null;
        }
    }

    function openTriggerFn(trigger) {
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        trigger.setAttribute('aria-expanded', 'true');
        trigger.classList.add('is-open');
        if (panel) {
            panel.setAttribute('aria-hidden', 'false');
            panel.classList.add('is-open');
            panel.style.maxHeight = panel.scrollHeight + 'px';
        }
        openTrigger = trigger;
    }

    triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
            var isCurrentlyOpen = trigger === openTrigger;

            if (openTrigger) {
                closeTrigger(openTrigger);
                openTrigger = null;
            }

            if (!isCurrentlyOpen) {
                openTriggerFn(trigger);
            }
        });
    });
});
